<template>
    <div>
        <div class="p-3 my-3 bg-light">
            <strong>Tuskey保険登録オプション</strong>
        </div>

        <div class="text-right">
            <a class="text-danger" href="https://www.bk.mufg.jp/ippan/kinri/list_j/kinri/kawase.html" target="_blank">三菱ＵＦＪ銀行為替相場一覧表へのリンクはこちら</a>
            <br>
            ※申告金額は千円単位切り上げとなります。
        </div>

        <div class="text-center">
            <h4>
                申告金額＝保険金額(JPY)
            </h4>
            <h4>
                {{ shipping_insurance.shipping_item_price_total | BaseNumberFormatter }}
            </h4>

            <h4>
                保険料(JPY)
            </h4>
            <h4>
                + {{ shipping_insurance.shipping_insurance_charge | BaseNumberFormatter }}
            </h4>

            <b-form-group class="text-center mt-4">
                 <b-form-radio-group
                     v-model="_value"
                     button-variant="outline-primary"
                     size="lg"
                     buttons
                     stacked
                     >
                     <b-form-radio :value="true">
                         Tuskey保険に加入する。<br>
                         為替及び千円切り上げ計算を確認しました。

                         <br>
                         <br>
                         <div class="alert alert-warning" role="alert">
                             3/31(月)21:00以降をもって外航貨物保険の新規付保は受付停止となります。
                         </div>
                     </b-form-radio>
                     <b-form-radio button-variant="outline-danger" :value="false">
                         Tuskey保険に加入しない。<br>
                         ラベル作成のみ。
                     </b-form-radio>
                 </b-form-radio-group>
            </b-form-group>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FormModal from '@/components/FormModal.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import InputError from '@/components/InputError.vue'
import GridPage from '@/components/GridPage.vue'
import LogTable from '@/components/LogTable.vue'
import SelectCountry from '@/components/SelectCountry.vue'
import SelectTaxTarget from '@/components/SelectTaxTarget.vue'

export default {
    components: {
        GridPage,
        FormModal,
        ItemBadges,
        LogTable,
        SelectCountry,
        SelectTaxTarget,
        InputError,
    },
    emits: [
        'save',
        'destroy',
    ],
    props: {
        value: {
            required: true,
            default() {
                return false
            },
        },
        items: {
            type: Array,
            required: true,
            default() {
                return []
            },
        },
        currency: {
            type: String,
            required: true,
            default() {
                return 'JPY'
            },
        },
        castPrice: {
            type: String,
            default() {
                return 'int'
            },
        },
    },
    data() {
        return {
            shipping_insurance: {
                shipping_insurance_charge: 0,
                shipping_item_price_total: 0,
            },
        }
    },
    computed: {
        ...mapGetters([
            'auth_uuid',
            'auth_level',
            'trans',
            'get_items_total',
        ]),
        _value: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
    watch:{ 
        items (newValue, oldValue) { 
            this.calcShippingInsurance()
        },
        currency (newValue, oldValue) { 
            this.calcShippingInsurance()
        },
    },
    mounted() {
//        this.timer = window.setInterval(this.interval, 10 * 1000)
//        this.interval()
    },
    destroyed() {
//        clearInterval(this.timer)
    },
    methods: {
        async calcShippingInsurance() {
            let total = this.get_items_total(this.items, this.castPrice)
////            total.total_item_price += 1
            let shipping_insurance = await this.$store
                .dispatch('insurance/calc_shipping_insurance', {
                    currency: this.currency,
                    price: total.total_item_price,
                })
                .then((response) => {
                    return response.data
                })
                .catch((error) => {
                    return null
                })

            if (!shipping_insurance) {
                alert('Tuskey保険の見積金額を取得できませんでした。')
                return
            }

            // re-calc
            total = this.get_items_total(this.items, this.castPrice)
            if (shipping_insurance.from !== this.currency
                || shipping_insurance.price !== total.total_item_price
            ) {
                this.calcShippingInsurance()
                return
            }

            this.$utils.set(this.shipping_insurance, shipping_insurance)

            if (this._value === true) {
                this._value = ''
//                const result = this.$utils.modalAlert(
//                    this,
//                    'Tuskey保険登録オプション',
//                    '保険料が再計算されました。'
//                )
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.item-name {
    font-size: 1.6em;
    margin-bottom: 0;
}
.item-price {
    font-size: 1.6em;
    margin-bottom: 0;
}
.shipping-address-th {
    width:0.1%;
    white-space: nowrap;
}
</style>

